import moment from 'moment';
import { ProfileUser } from 'core/models/account/profile';
import { GetSubscriptionDTO } from 'core/models/product/subscription.dto';
import { PaymentRequestRedirectResponse } from 'core/services/api/payment/payment-dpp';
import { ProfileService } from 'core/services/api/profile';
import { SubscriptionService } from 'core/services/api/subscriptions';
import { SiteConfigStore } from 'core/stores/site-config.store';
import { PaymentRequestType } from './payment-request';

export class PaymentRequestPSH implements PaymentRequestType<PaymentRequestRedirectResponse> {
  orderId!: string;

  constructor(private request: any) { }

  addValues(values: { [key: string]: number | string | undefined }) {
    this.request = {
      ...this.request,
      ...values
    }
    return this;
  }

  getDependantValues() {
    return Promise.all(
      [
        !this.request.smartCardNumber ? SubscriptionService.getSubscriptions(this.request.customerNumber, this.request.countryName) : Promise.resolve({} as GetSubscriptionDTO),
        (!this.request.firstName || !this.request.name) ? ProfileService.getProfile(this.request.customerNumber, this.request.countryName) : Promise.resolve({} as ProfileUser),
      ]
    )
      .then(
        ([subscriptions, profile]) => {
          const pck = subscriptions?.subscriptions?.find(sub => sub.isPrimarySc); // res.subscriptions.find(sub => sub.smartcardNumber === quote.lineItems[0]?.serialNumber);
          if (subscriptions?.subscriptions) {
            this.addValues({
              smartcardNumber: `${pck?.smartcardNumber}`
            })
          }
          if (profile?.surname) {
            this.addValues({
              firstName: profile?.firstName,
              surname: profile?.surname,
            })
          }
          return this;
        }
      );
  }

  toPaymentRequestObject() {
    const { currencyCode, countryName, lang, dueDate, customerNumber, smartcardNumber, amount, firstName, surname, successReturnURL, failureReturnURL } = this.request;
    const today = moment();
    const orderId = `${customerNumber}${Date.now()}`;
    this.orderId = orderId;
    const successReturnUrlOverride = successReturnURL?.includes('local') ?
      "https://unificationdev.azurewebsites.net/en-za/mydstv-residential#/account/view-balance?payRes=success" : successReturnURL;
    const failureReturnUrlOverride = failureReturnURL?.includes('local') ?
      'https://unificationdev.azurewebsites.net/en-za/mydstv-residential#/account/view-balance?payRes=failure' : failureReturnURL;
    return {
      successUrl: successReturnUrlOverride,
      failureUrl: failureReturnUrlOverride,
      amountToPay: `${amount}`,
      customerNumber: customerNumber,
      smartcardNumber: smartcardNumber,
      dueDate: dueDate && moment(dueDate).isSameOrAfter(today) ? dueDate : today.toJSON(),
      orderId: orderId,
      firstName: firstName,
      surname: surname,
      country: countryName,
      businessUnit: SiteConfigStore.businessUnit(),
      channel: "dstvsa",
      paymentType: "DstvPayment",
      languageCode: lang,
      currency: currencyCode,
    }
  }

  toTokenRequestObject() {
    return this.toPaymentRequestObject()
  }

  handleResponse(response: PaymentRequestRedirectResponse) {
    window.location.assign(response.redirectUrl);
    return Promise.resolve(false)
  }
}